import {
    SET_IS_ERROR_LEAD_CONVERSATION,
    SET_IS_LOADING_LEAD_CONVERSATION,
    SET_IS_SUCCESS_LEAD_CONVERSATION,
} from '../constants/get_lead_conversation.constants';

export const setIsLoadingLeadConversation = (isLoading) => ({
    type: SET_IS_LOADING_LEAD_CONVERSATION,
    isLoading,
});

export const setIsSuccessLeadConversation = (payload) => ({
    type: SET_IS_SUCCESS_LEAD_CONVERSATION,
    payload,
});

export const setIsErrorLeadConversation = (error) => ({
    type: SET_IS_ERROR_LEAD_CONVERSATION,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_lead_conversation.actions.js